export const GET_USER_PROFILE = 'GET_USER_PROFILE'
export const UPDATE_USER_PROFILE = 'UPDATE_USER_PROFILE'
export const NEW_USER_PWD = 'NEW_USER_PWD'
export const UP_USER_LOADING = 'UP_USER_LOADER'
export const LOADING_PWD = 'LOADING_PWD'
export const UPDATE_ERROR = 'UPDATE_ERROR'